module.exports = __webpack_public_path__ + "img/borderRightLongWhite.290cb805.svg";